<template>
  <div>
    <b-card>
      <b-row>
        <b-col class="text-right">
          <b-button @click="AddAllowance()" variant="primary" v-ripple.400="'rgba(255, 255, 255, 0.15)'">
            Tambah
          </b-button>
        </b-col>
      </b-row>
      <br />
      <b-table :current-page="0" :busy="loading" show-empty :per-page="filter.size" :fields="fields" :items="items" :responsive="true">
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
        <template #empty="scope">
          <h4 class="text-center" >{{ scope.emptyText }}</h4>
        </template>
        <template #cell(startPeriod)="data">
          <div>
            {{ FormatDate(data.item.startPeriod) }}
          </div>
        </template>
        <template #cell(endPeriod)="data">
          <div>
            {{ FormatDate(data.item.endPeriod) }}
          </div>
        </template>
        <template #cell(actions)="data">
          <div class="options-table">
            <b-button @click="ViewAllowance(data)" variant="outline-primary" size="sm" class="mr-1">View</b-button>
            <b-button @click="EditAllowance(data)" variant="outline-primary" size="sm" class="mr-1">Edit</b-button>
            <b-overlay :show="data.item.isLoadingApprove" class="loading-approve" rounded opacity="0.6" spinner-small spinner-variant="primary">
              <b-button @click="QuestionApprove(data)" v-if="data.item.status === 'DRAFT'" variant="outline-primary" size="sm" class="mr-1">Approve</b-button>
            </b-overlay>
          </div>
        </template>
      </b-table>
      <div class="mt-2">
        <b-pagination v-model="filter.page" :total-rows="pagination.total" :per-page="filter.size">

        </b-pagination>
      </div>
    </b-card>
    <b-modal id="form-periode-allowance-modal" size="lg">
      <validation-observer ref="performaceForm">
        <form>
          <horizontal-form-group label="Periode Berlaku">
            <validation-provider #default="{ errors }" name="Periode Berlaku" rules="required">
              <b-form-datepicker v-model="formPayload.startDate"></b-form-datepicker>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </horizontal-form-group>

          <horizontal-form-group label="Periode Berakhir">
            <validation-provider #default="{ errors }" name="Periode Berakhir" rules="required">
              <b-form-datepicker v-model="formPayload.endDate"></b-form-datepicker>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </horizontal-form-group>
        </form>
      </validation-observer>
      <template #modal-footer="{}">
        <b-button class="d-flex" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" :disabled="isLoadingForm" @click="submitItem()">
          <b-spinner small variant="light" class="mr-1" v-if="isLoadingForm" /> Simpan
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import Ripple from "vue-ripple-directive";
import BaseTable from "@/components/BaseTable.vue";
import { BCard, BRow, BCol, BButton, BFormInput,BFormGroup,BTable,BPagination,BOverlay,BSpinner, BModal,BFormDatepicker } from "bootstrap-vue";
import {
  PerformanceAllowanceService,
  PerformanceStatusAllowanceService
} from '../../services/performance-allowance.service'
import { successNotification, errorNotification } from "@/auth/utils";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import utility from '../../libs/utility'
export default {
  name: "PerformanceAllowance",
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BFormGroup,
    BTable,
    BPagination,
    BOverlay,
    BSpinner,
    BModal,
    ValidationProvider,
    ValidationObserver,
    required,
    BFormDatepicker
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      fields: [
        {
          key: "startPeriod",
          label: "Periode Berlaku"
        },
        {
          key: "endPeriod",
          label: "Periode Berakhir"
        },
        {
          key: "status",
          label: "Status"
        },
        {
          key: 'actions',
          label: 'Aksi'
        }
      ],
      items: [],
      loading: false,
      isLoadingForm: false,
      editId: null,
      pagination: {
        total: 0
      },
      filter: {
        title: "",
        page: 1,
        size: 10
      },
      formPayload: {
        startDate: '',
        endDate: ''
      },
    }
  },
  watch: {
    'filter.page': function () {
      this.GetPerformanceAllowance();
    }
  },
  methods: {
    AddAllowance() {
      this.ResetField();
      this.$bvModal.show('form-periode-allowance-modal');
    },
    EditAllowance(data) {
      this.formPayload.startDate = data.item.startPeriod;
      this.formPayload.endDate = data.item.endPeriod;
      this.editId = data.item.performAllowancePeriodId;
      this.$bvModal.show('form-periode-allowance-modal');
    },
    ViewAllowance(data) {
      // window.console.log(data);
      this.$router.push(`/approval-kpi-allowance/view/${data.item.performAllowancePeriodId}`);
    },
    QuestionApprove(data) {
      this.$swal({
        title: "Anda yakin?",
        text: "Anda yakin ingin Menyetujui data ini?",
        icon: "info",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.Approve(data);
        }
      });
    },
    async Approve(data) {
      data.item.isLoadingApprove = true;
      let req = {
        status: "APPROVE"
      };
      await PerformanceStatusAllowanceService.update(data.item.performAllowancePeriodId, req)
        .then((result) => {
          window.console.log(result);
          if (result.code === "00") {
            this.GetPerformanceAllowance();
          }
          data.item.isLoadingApprove = false;
        })
        .catch((e) => {
          errorNotification(this, "Oops!", e.message);
          data.item.isLoadingApprove = false;
        });
    },
    ResetField() {
      this.editId  =  null;
      this.formPayload = {
        startDate: '',
        endDate: ''
      };
      this.$bvModal.hide('form-periode-allowance-modal');
    },
    async GetPerformanceAllowance() {
      this.loading = true;
      let req = {
        page: this.filter.page,
        size: this.filter.size
      };
      this.items = [];
      await PerformanceAllowanceService.find(req)
        .then((result) => {
          window.console.log(result);
          if (result.code === "00") {
            result.data.content.forEach((items) => {
              items['isLoadingApprove'] = false;
              this.items.push(items);
            });
            this.pagination.total = result.data.total;
          }
          this.loading = false;
        })
        .catch((e) => {
          this.loading  =  false;
          errorNotification(this, "Oops!", e.message);
        });
    },
    FormatDate(date) {
      return utility.FormatDate(date);
    },
    submitItem() {
      this.$refs.performaceForm.validate()
        .then((result) => {
          if (result) {
            if (this.editId === null) {
              this.SaveItem();
            } else {
              this.UpdateItem();
            }
          }
        });
    },
    async UpdateItem() {
      this.isLoadingForm = true;
      let req = {
        startPeriod: this.formPayload.startDate,
        endPeriod: this.formPayload.endDate
      };
      await PerformanceAllowanceService.update(this.editId, req)
        .then((result) => {
          window.console.log(result);
          if (result.code === "00") {
            successNotification(this,result.data.message);
            this.GetPerformanceAllowance();
            this.ResetField();
          }
          this.isLoadingForm = false;
        })
        .catch((e) => {
          errorNotification(this, "Oops!", e.message);
          this.isLoadingForm = false;
        });
    },
    async SaveItem() {
      this.isLoadingForm = true;
      let req = {
        startPeriod: this.formPayload.startDate,
        endPeriod: this.formPayload.endDate
      };
      await PerformanceAllowanceService.create(req)
        .then((result) => {
          window.console.log(result);
          if (result.code === "00") {
            successNotification(this,result.message);
            this.ResetField();
            this.GetPerformanceAllowance();
          }
          this.isLoadingForm = false;
        })
        .catch((e) => {
          errorNotification(this, "Oops!", e.message);
          this.isLoadingForm = false;
        });
    },
  },
  mounted() {
    this.GetPerformanceAllowance();
  }
}
</script>
